<template>
  <div class="ugc-section">
    <div class="ugc-title"></div>
    <div class="tab-list">
      <div
        class="tab1 tab btns"
        :class="{ active: activeUgcTab == UgcTab.UgcTypeMyROMemory }"
        @click="switchUgcTab(UgcTab.UgcTypeMyROMemory)"
      ></div>
      <div
        class="tab2 tab btns"
        :class="{ active: activeUgcTab == UgcTab.UgcTypeCostume }"
        @click="switchUgcTab(UgcTab.UgcTypeCostume)"
      ></div>
      <div
        class="tab3 tab btns"
        :class="{ active: activeUgcTab == UgcTab.UgcTypePhoto }"
        @click="switchUgcTab(UgcTab.UgcTypePhoto)"
      ></div>
    </div>
    <div class="banner-section">
      <div class="banner" :class="`banner-${activeUgcTab}`"></div>
      <div class="banner-btn btns" @click="goUgcList()"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, onMounted, onUnmounted } from "vue";
import { UgcTab } from "../typings";

const title = {
  [UgcTab.UgcTypeMyROMemory]: "我的RO回憶",
  [UgcTab.UgcTypeCostume]: "時裝設計",
  [UgcTab.UgcTypePhoto]: "美照分享",
};

const activeNavTab = inject("activeNavTab");
const initClass = inject("initClass");
const goUgcList = inject("goUgcList");

const activeUgcTab = inject("activeUgcTab", ref(UgcTab.UgcTypeMyROMemory));

// 页面停留时间追踪
const viewPageStartTime = ref(null);

// 计算浏览时长
const formatDuration = (startTime, endTime) => {
  const duration = Math.floor((endTime - startTime) / 1000); // 转换为秒
  // 格式化为 xxHxxMxxS
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;
  return `${hours > 0 ? hours + "H" : ""}${
    minutes > 0 ? minutes + "M" : ""
  }${seconds}S`;
};

// 上报页面停留时间
const reportStayTime = () => {
  if (viewPageStartTime.value) {
    window.activityDataLayer.push({
      eventName: "stay_time",
      eventType: "首页",
      eventValue: formatDuration(viewPageStartTime.value, new Date()),
      aid: window.activity_name,
      gameId: window.game_id,
    });
  }
};

const getUgcTypeText = (type) => {
  return title[type];
};

// 切换UGC内容标签
const switchUgcTab = (tab) => {
  activeUgcTab.value = tab;
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: getUgcTypeText(tab),
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
};

// 生命周期
onMounted(() => {
  viewPageStartTime.value = new Date();
});

onUnmounted(() => {
  reportStayTime();
});
</script>
